import AsideDefault from './AsideDefault'

export default AsideDefault
